import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';
import { Router, RouterEvent } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';

import { AppComponentImports } from '.';
import { GetCollectionsQuery, GetCollectionsQueryVariables } from './common/generated-types';
import { GET_COLLECTIONS } from './common/graphql/documents.graphql';
import { ActiveService } from './core/providers/active/active.service';
import { DataService } from './core/providers/data/data.service';
import { StateService } from './core/providers/state/state.service';

@Component({
    standalone: true,
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'vsf-root',
    imports: AppComponentImports,
    templateUrl: './app.component.html',
    // styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
    private router = inject(Router);
    private stateService = inject(StateService);
    private dataService = inject(DataService);
    private activeService = inject(ActiveService);

    cartDrawerVisible$: Observable<boolean>;
    mobileNavVisible$: Observable<boolean>;
    mobileFiltersVisible$: Observable<boolean>;
    isHomePage$: Observable<boolean>;
    topCollections$: Observable<GetCollectionsQuery['collections']['items']>;
    cartItemCount$: Observable<number>;

    navigation = {
        support: [
            {name: 'Help', href: '#'},
            {name: 'Track order', href: '#'},
            {name: 'Shipping', href: '#'},
            {name: 'Returns', href: '#'},
        ],
        company: [
            {name: 'About', href: '#'},
            {name: 'Blog', href: '#'},
            {name: 'Corporate responsibility', href: '#'},
            {name: 'Press', href: '#'},
        ],
    };

    ngOnInit(): void {
        this.cartDrawerVisible$ = this.stateService.select(state => state.cartDrawerOpen);
        this.mobileNavVisible$ = this.stateService.select(state => state.mobileNavMenuIsOpen);
        this.mobileFiltersVisible$ = this.stateService.select(state => state.mobileFiltersIsOpen);
        this.isHomePage$ = this.router.events.pipe(
            filter<any>(event => event instanceof RouterEvent),
            map((event: RouterEvent) => event.url === '/'),
        );
        this.topCollections$ = this.dataService.query<GetCollectionsQuery, GetCollectionsQueryVariables>(GET_COLLECTIONS, {
            options: {take: 25, topLevelOnly: true}
        }).pipe(
            map(({collections}) => collections.items)
        );

        this.cartItemCount$ = this.activeService.activeOrder$.pipe(
            map(order => {
                if (!order || !order.lines) {
                    return 0;
                }
                return order.lines.length;
            })
        );
    }

    closeCartDrawer() {
        this.stateService.setState('cartDrawerOpen', false);
    }
}
